varying vec2 vBumpUV;
varying vec3 vNormalW;
varying vec3 vPositionW;
varying float vHeight;
